export interface LinkSend {
  sent: boolean;
}
